import get from "lodash/get";
import { GetScore, Lifter, Meet } from "types";
import { getRealAge, getTotal } from "util/lifterHelper";

const mccullochCoefTable = {
  41: 1.01,
  42: 1.02,
  43: 1.031,
  44: 1.043,
  45: 1.055,
  46: 1.068,
  47: 1.082,
  48: 1.097,
  49: 1.113,
  50: 1.13,
  51: 1.147,
  52: 1.165,
  53: 1.184,
  54: 1.204,
  55: 1.225,
  56: 1.246,
  57: 1.268,
  58: 1.291,
  59: 1.315,
  60: 1.34,
  61: 1.366,
  62: 1.393,
  63: 1.421,
  64: 1.45,
  65: 1.48,
  66: 1.511,
  67: 1.543,
  68: 1.576,
  69: 1.61,
  70: 1.645,
  71: 1.681,
  72: 1.718,
  73: 1.756,
  74: 1.795,
  75: 1.835,
  76: 1.876,
  77: 1.918,
  78: 1.961,
  79: 2.005,
  80: 2.05,
  81: 2.096,
  82: 2.143,
  83: 2.19,
  84: 2.238,
  85: 2.287,
  86: 2.337,
  87: 2.388,
  88: 2.44,
  89: 2.494,
  90: 2.549,
};

const mccullochCoef = function (age: number | null | undefined) {
  if (age) {
    // you don't get any extra points for being over 90
    // coef is always 1 for 40 or younger
    if (age > 90) {
      age = 90;
    }

    return get(mccullochCoefTable, age, 1);
  } else {
    return 1.0;
  }
};

const fosterCoefTable = {
  14: 1.23,
  15: 1.18,
  16: 1.13,
  17: 1.08,
  18: 1.06,
  19: 1.04,
  20: 1.03,
  21: 1.02,
  22: 1.01,
};

const fosterCoef = function (age: number | null | undefined) {
  if (age) {
    // you don't get any extra points for being under 14
    if (age < 14) {
      age = 14;
    }

    return get(fosterCoefTable, age, 1);
  } else {
    return 1;
  }
};

const usaplMastersCoefTable = {
  41: 1.003,
  42: 1.008,
  43: 1.014,
  44: 1.02,
  45: 1.026,
  46: 1.033,
  47: 1.04,
  48: 1.048,
  49: 1.057,
  50: 1.066,
  51: 1.075,
  52: 1.086,
  53: 1.096,
  54: 1.108,
  55: 1.12,
  56: 1.134,
  57: 1.147,
  58: 1.162,
  59: 1.178,
  60: 1.194,
  61: 1.211,
  62: 1.23,
  63: 1.249,
  64: 1.269,
  65: 1.29,
  66: 1.312,
  67: 1.335,
  68: 1.36,
  69: 1.385,
  70: 1.411,
  71: 1.439,
  72: 1.468,
  73: 1.498,
  74: 1.529,
  75: 1.562,
  76: 1.596,
  77: 1.631,
  78: 1.668,
  79: 1.706,
  80: 1.745,
  81: 1.786,
  82: 1.829,
  83: 1.873,
  84: 1.918,
  85: 1.965,
  86: 2.013,
  87: 2.064,
  88: 2.115,
  89: 2.169,
  90: 2.224,
  91: 2.281,
  92: 2.34,
  93: 2.4,
  94: 2.462,
  95: 2.526,
};

const usaplMastersCoef = function (age: number | null | undefined) {
  if (age) {
    // you don't get any extra points for being over 95
    // coef is always 1 for 40 or younger
    if (age > 95) {
      age = 95;
    }

    return get(usaplMastersCoefTable, age, 1);
  }

  return 1;
};

export const ageCoef = function (lifter: Lifter, meet: Meet) {
  const age = getRealAge(lifter, meet);

  if (meet.federation === "USAPL") {
    return usaplMastersCoef(age) * fosterCoef(age);
  }

  // one of these will always be 1
  return mccullochCoef(age) * fosterCoef(age);
};

export const getAgeAdjustedTotal: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });

  return total * ageCoef(lifter, meet);
};
